module.exports = __webpack_public_path__ + "img/kids.923fd44d.jpeg";